import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixel, trackPageView } from '../lib/metaPixel';
/**
 * Initializes the Meta Pixel once on mount and fires a PageView event
 * on every route change. Renders nothing.
 */
export const MetaPixelTracker = () => {
  const location = useLocation();
  // Initialize once
  useEffect(() => {
    initMetaPixel();
  }, []);
  // Fire PageView on initial mount and on every route change.
  // Small delay ensures the pixel script has loaded before firing.
  useEffect(() => {
    const timer = setTimeout(() => {
      trackPageView();
    }, 300);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  return null;
};